import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-helpfile',
  templateUrl: './helpfile.component.html',
  styleUrls: ['./helpfile.component.css']
})
export class HelpfileComponent implements OnInit {

  dataList = [{
    id: 1,
    steps: [
      {
        id:1,
        desc: "Correcting hazards found during routine Inspections is an important part of the construction process This guide is intended to assist users with abatement of hazards indicated in Office Inspection Reports on the SFI Data Management System",
        step: '#1) Begin by logging into your account at ',
        src: '../../assets/img/help-imgs/office/o-login.png',
        srcMob: '../../assets/img/help-imgs/mobile/mi-login.png'
      },
      {
        step: '#2) Once logged in, go to the taskbar on the left side of the screen, select inspections, then select Office Inspection',
        src: '../../assets/img/help-imgs/office/o-of.png',
       
        srcMob: '../../assets/img/help-imgs/mobile/mo-oi.png'
      },
      {
        step: '#3) Inspections needing abatement will appear with a red exclamation mark beside them. Click on the report # you wish to view/ update',
        src: '../../assets/img/help-imgs/office/o-rn.png',
        //srctab: '../../assets/img/help-imgs/officeMainTab (2).png',
        srcMob: '../../assets/img/help-imgs/mobile/mo-rn.png'
      },
      {
        step: '#4) Items indicated as needing abatement will have an abatement toggle. Change the toggle to yes to indicate abatement.',
        src: '../../assets/img/help-imgs/office/o-abatement-no.png',
       // srctab: '../../assets/img/help-imgs/officeAbatementTab (2).png',
        srcMob: '../../assets/img/help-imgs/mobile/mo-abatement-no.png'
      },
      {
        step: '#5) Next, you will add the description of how the hazard(s) were abated/ corrected as well as the abatement date. Repeat as necessary until all abatements have been noted. If no abatement toggle is present, just add the abatement date and abatement description.',
        src: '../../assets/img/help-imgs/office/o-abatement-yes.png',
        //srctab: '../../assets/img/help-imgs/officeAbatementYesTab (2).png',
        srcMob: '../../assets/img/help-imgs/mobile/mo-abatement-yes.png'
      },
      {
        step: '#6) Once all abatements have been made, scroll to the bottom of the page and select “Save and Complete”',
        src: '../../assets/img/help-imgs/office/o-save-complete.png',
       // srctab: '../../assets/img/help-imgs/officeCmpTab (2).png',
        srcMob: '../../assets/img/help-imgs/mobile/mo-img-1.png'
      },
      {
        step: '#7) A prompt will appear confirming that you wish to Complete the report. If you are ready to complete, select “Yes”. Selecting “No” will return you to the report',
        src: '../../assets/img/help-imgs/office/o-confirming.png',
       // srctab: '../../assets/img/help-imgs/officeSaveCmpTab (2).png',
        srcMob: '../../assets/img/help-imgs/mobile/mo-img-1.png'
      },
      {
        step: '#8) A second prompt will now appear asking if you would like to E-mail the New report now,Email updated report Now, or E-mail later.Select E-mail updated report to send the Notification to the corresponding distribution list for the site.',
        src: '../../assets/img/help-imgs/office/o-prompt-email.png',
        //srctab: '../../assets/img/help-imgs/officeEmailTab (2).png',
        srcMob: '../../assets/img/help-imgs/mobile/mo-prompt-email.png'
      },
      {
        step: '#9) A notification will appear at the top of the screen informing you that the Email has been sent successfully.The Office Inspection Report is now Complete!',
        src: '../../assets/img/help-imgs/office/o-prompt-successfullyl.png',
       // srctab: '../../assets/img/help-imgs/officeEmailSaveTab (2).png',
        srcMob: '../../assets/img/help-imgs/mobile/mo-prompt-successfully.png'
      }
    ]
  },
  {
    id: 2,
    steps: [
      {
        id:2,
        desc: "Access database at www.sficompliance.com and then click on Client Login or go directly to the Data Management System (DMS) https://dms.sficompliance.com",
        step: '#1 Enter your username (email address) and password or click on forgot password feature)',
        src: '../../assets/img/help-imgs/workplace/w-login.png',
        //srctab: '../../assets/img/help-imgs/loginTab.png',
        srcMob: '../../assets/img/help-imgs/mobile/mi-login.png'
      },
      {
        step: '#2 Once logged in the DMS, click on Inspections and then Workplace Safety Checklist. This will allow you to view all Workplace Safety Checklist inspections for your company and the region you are assigned.',
        src: '../../assets/img/help-imgs/workplace/w-wsc.png',
        //srctab: '../../assets/img/help-imgs/officeTab (2).png',
        srcMob: '../../assets/img/help-imgs/mobile/mw-wsc.png'
      },
      {
        step: '#3 You can search by Site Name, Date, Inspection ID, etc. ',
        // src: '../../assets/img/help-imgs/workplace/w-login.png',
        // srctab: '../../assets/img/help-imgs/officeTab (2).png',
        srcMob: ''
      },
      {
        step: '#4 Reports with a green check mark next to them are fully abated reports and no other abatement updates are needed. Reports with a red exclamation point next to them are incomplete reports that still need to be updated with appropriate abatements. ',
        // src: '../../assets/img/help-imgs/workplace/w-login.png',
        // srctab: '../../assets/img/help-imgs/officeTab (2).png',
        srcMob: ''
      },
      {
        step: '#5 Select report by clicking report number in left hand column. This will open up the selected report. ',
        src: '../../assets/img/help-imgs/workplace/w-rn.png',
        //srctab: '../../assets/img/help-imgs/officeTab (2).png',
        srcMob: '../../assets/img/help-imgs/mobile/mw-rn.png'
      },
      {
        step: '#6 Once your inspection report is loaded, you may scroll down to see line items indicated “no”.There is an abatement toggle that will appear below these items.',
        src: '../../assets/img/help-imgs/workplace/w-abatement-no.png',
        //srctab: '../../assets/img/help-imgs/officeTab (2).png',
        srcMob: '../../assets/img/help-imgs/mobile/mw-abatement-no.png'
      },
      {
        step: '#7 Change the “NO” to “YES under Abated.Enter abatement method and abatement date.When entering how the hazard(s) were abated,be concise but specific. ',
        src: '../../assets/img/help-imgs/workplace/w-abatement-yes.png',
       // srctab: '../../assets/img/help-imgs/officeTab (2).png',
        srcMob: '../../assets/img/help-imgs/mobile/mw-abatement-yes.png'
      },
      {
        step: '#8 Click Save report (Blue icon) ',
        src: '../../assets/img/help-imgs/workplace/w-save-report.png',
       // srctab: '../../assets/img/help-imgs/officeTab (2).png',
        srcMob: '../../assets/img/help-imgs/mobile/mw-confirming.png'
      },
      {
        step: '#9 The hazard will now show as abated. ',
        // src: '../../assets/img/help-imgs/6.png',
        // srctab: '../../assets/img/help-imgs/officeTab (2).png',
        srcMob: ''
      },
      {
        step: '#10 Repeat accordingly until all violations  have been abated and report shows an Abatement Score of 100%. ',
        // src: '../../assets/img/help-imgs/6.png',
        // srctab: '../../assets/img/help-imgs/officeTab (2).png',
        srcMob: ''
      },
      {
        step: '#11 You now have the ability to send out the Updated notification to the rest of your team members showing all items have been abated. ',
        src: '../../assets/img/help-imgs/workplace/w-send-email.png',
       // srctab: '../../assets/img/help-imgs/officeTab (2).png',
        srcMob: '../../assets/img/help-imgs/mobile/mw-prompt-email.png'
      },
      {
        step: '#12 If you want to print or download the full report, you can click on the “Preview” or “Download” buttons at any time.',
        // src: '../../assets/img/help-imgs/7.png',
        // srctab: '../../assets/img/help-imgs/officeTab (2).png',
        srcMob: ''
      },
      
  ]
  },
  {
    id: 3,
    steps: [
      {
        id:3,
        desc: "Access database at www.sficompliance.com and then click on Client Login or go directly to the Data Management System (DMS) https://dms.sficompliance.com",
        step: '#1 Enter your username (email address) and password or click on forgot password feature)',
        src: '../../assets/img/help-imgs/jobsite/i-login.png',
       // srctab: '../../assets/img/help-imgs/loginTab.png',
        srcMob: '../../assets/img/help-imgs/mobile/mi-login.png'
      },
      {
        step: '#2 Once logged in the DMS, click on Inspections and then Jobsite Inspections.This will allow you to view all Jobsite Inspections for your company and the region you are assigned.',
        src: '../../assets/img/help-imgs/jobsite/i-rn.png',
       // srctab: '../../assets/img/help-imgs/officeTab (2).png',
        srcMob: '../../assets/img/help-imgs/mobile/mi-rn.png'
      },
      {
        step: '#3 You can search by Site Name, Date, Inspection ID, etc. ',
        // src: '../../assets/img/help-imgs/3.png',
        // srctab: '../../assets/img/help-imgs/officeTab (2).png',
        srcMob: ''
      },
      {
        step: '#4 Reports with a green check mark next to them are fully abated reports and no other abatement updates are needed.Reports with a red exclamation point next to them are incomplete reports that still need to be updated with appropriate abatements.',
        // src: '../../assets/img/help-imgs/3.png',
        // srctab: '../../assets/img/help-imgs/officeTab (2).png',
        srcMob: ''
      },
      {
        step:'#5 Select report by clicking report number in left hand column. This will open up the selected report.',
        src: '../../assets/img/help-imgs/jobsite/i-ji.png',
       // srctab: '../../assets/img/help-imgs/officeTab (2).png',
        srcMob: '../../assets/img/help-imgs/mobile/mj-edit.png'
      },
      {
        step: '#6 Once your inspection report is loaded, you will again see green checkmarks or red exclamation points gain.Click on edit for the hazards that still needs to be abated.',
        src: '../../assets/img/help-imgs/jobsite/i-edit-hazards.png',
       // srctab: '../../assets/img/help-imgs/officeTab (2).png',
        srcMob: '../../assets/img/help-imgs/mobile/mj-edit1.png'
      },
      {
        step: '#7 Change the “NO” to “YES under Abated. Enter abatement method and abatement date. When entering how the hazard(s) were abated, be concise but specific. (see examples at the bottom of the page)',
        src: '../../assets/img/help-imgs/jobsite/i-abatement-yes.png',
       // srctab: '../../assets/img/help-imgs/officeTab (2).png',
        srcMob: '../../assets/img/help-imgs/mobile/mj-abatement-yes.png'
      },
      {
        step: '#8 Click Save and Close and then continue with other unabated violations.',
        // src: '../../assets/img/help-imgs/4.png',
        // srctab: '../../assets/img/help-imgs/officeTab (2).png',
        srcMob: ''
      },
      {
        step: '#9 The hazard will now show a green checkmark.',
        // src: '../../assets/img/help-imgs/4.png',
        // srctab: '../../assets/img/help-imgs/officeTab (2).png',
         srcMob: ''
      },
      {
        step: '#10 Repeat accordingly until all violations completed and report shows an Abatement Score of 100%.',
        // src: '../../assets/img/help-imgs/4.png',
        // srctab: '../../assets/img/help-imgs/officeTab (2).png',
         srcMob: ''
      },
      {
        step: '#11 You can add pictures to show the abatement as well. Make sure to only upload abatement pictures.',
        // src: '../../assets/img/help-imgs/4.png',
        // srctab: '../../assets/img/help-imgs/officeTab (2).png',
         srcMob: ''
      },
      {
        step: '#12 You can also add comments to the report if you’d like to add additional information. Do this by clicking on Comments and then Add New Comments.',
        src: '../../assets/img/help-imgs/jobsite/i-add-hazards.png',
        //srctab: '../../assets/img/help-imgs/officeTab (2).png',
        srcMob: '../../assets/img/help-imgs/mobile/mj-hazards.png'
      },
      {
        step: '#13 You now have the ability to send out the Updated Inspection Notification to the rest of your team members showing all items have been abated.',
        src: '../../assets/img/help-imgs/jobsite/i-send-email.png',
        
        srcMob: '../../assets/img/help-imgs/3wm.png'
      },
      {
        step: '#14 If you want to print or download the full report, you can click on the “Preview” or “Download” buttons at any time.',
        // src: '../../assets/img/help-imgs/4.png',
        // srctab: '../../assets/img/help-imgs/officeTab (2).png',
        // srcMob: '../../assets/img/help-imgs/3wm.png'
      },


  ]
  }]
  stepsList: [] = [];
  title: string;
  isLoading: boolean=false;

  constructor() { }

  ngOnInit(): void {
    console.log('array of list', this.dataList)
    let id = 1;
    this.title = 'OFFICE INSPECTION ABATEMENT PROCESS 2022'
    let item
    item = this.dataList.filter(x => x.id == id);
    this.stepsList = item[0].steps;
    console.log('array of listfilter', item[0].steps)
  }
  onClickLink(index) {
    this.isLoading = true
    if(index == 1){
      this.title = 'OFFICE INSPECTION ABATEMENT PROCESS 2022'
    }else if(index == 2){
      this.title = 'Workplace Safety Checklist Abatement Process'
    } else if(index == 3){
      this.title = 'SFI INSPECTION ABATEMENT PROCESS'
    }
    console.log('array of list', this.dataList)
    let item
    item = this.dataList.filter(x => x.id == index);
    this.stepsList = item[0].steps;
    console.log('array of listfilter', item[0].steps);
    this.isLoading = false
  }

}
